import { h } from "vue";
import type { IconSet, IconProps } from "vuetify";

// Heading pictograms
import iconVerificationPhone from "./icons/icon-verification-phone.vue";
import iconVerificationEmail from "./icons/icon-verification-email.vue";
import iconLogin from "./icons/icon-login.vue";
import iconEmploymentInfo from "./icons/icon-employment-info.vue";
import iconFinancialInfo from "./icons/icon-financial-info.vue";
import iconFinancingOptions from "./icons/icon-financing-options.vue";
import iconPrecheck from "./icons/icon-precheck.vue";
import iconPurchaseIdentificationInfo from "./icons/icon-purchase-identification-info.vue";
import iconInstallmenPlanSelection from "./icons/icon-installment-plan-selection.vue";
import iconContractInfo from "./icons/icon-contract-info.vue";
import iconContractEndFail from "./icons/icon-contract-end-fail.vue";
import iconContractEndSuccess from "./icons/icon-contract-end-success.vue";

// Left menu icons
import iconMenuDomovInactive from "./icons/icon-menu-home-inactive.vue";
import iconMenuDomovActive from "./icons/icon-menu-home-active.vue";
import iconMenuPogodbeInactive from "./icons/icon-menu-contracts-inactive.vue";
import iconMenuPogodbeActive from "./icons/icon-menu-contracts-active.vue";
import iconMenuIzracunLimitaInactive from "./icons/icon-menu-limit-calc-inactive.vue";
import iconMenuIzracunLimitaActive from "./icons/icon-menu-limit-calc-active.vue";
import iconMenuIzracunObrokaInactive from "./icons/icon-menu-installment-calc-inactive.vue";
import iconMenuIzracunObrokaActive from "./icons/icon-menu-installment-calc-active.vue";

// App bar icons
import iconAppBarInformacijeActive from "./icons/icon-app-bar-info-active.vue";
import iconAppBarInformacijeInactive from "./icons/icon-app-bar-info-inactive.vue";
import iconAppBarCertificateActive from "./icons/icon-app-bar-certificate-active.vue";
import iconAppBarCertificateInactive from "./icons/icon-app-bar-certificate-inactive.vue";
import iconAppBarContactActive from "./icons/icon-app-bar-contact-active.vue";
import iconAppBarContactInactive from "./icons/icon-app-bar-contact-inactive.vue";

// Password show/hide icons
import iconPasswordVisible from "./icons/icon-password-visible.vue";
import iconPasswordNotVisible from "./icons/icon-password-not-visible.vue";


const customSvgNameToComponent: any = {
  iconVerificationPhone,
  iconVerificationEmail,
  iconLogin,
  iconEmploymentInfo,
  iconFinancialInfo,
  iconFinancingOptions,
  iconPrecheck,
  iconPurchaseIdentificationInfo,
  iconInstallmenPlanSelection,
  iconContractInfo,
  iconContractEndFail,
  iconContractEndSuccess,

  iconMenuDomovInactive,
  iconMenuDomovActive,
  iconMenuPogodbeInactive,
  iconMenuPogodbeActive,
  iconMenuIzracunLimitaInactive,
  iconMenuIzracunLimitaActive,
  iconMenuIzracunObrokaInactive,
  iconMenuIzracunObrokaActive,

  iconAppBarInformacijeActive,
  iconAppBarInformacijeInactive,
  iconAppBarCertificateActive,
  iconAppBarCertificateInactive,
  iconAppBarContactActive,
  iconAppBarContactInactive,

  iconPasswordVisible,
  iconPasswordNotVisible
};

type IconSet = typeof IconSet;
type IconProps = typeof IconProps;

const customSVGs: IconSet = {
  component: (props: IconProps) => h(customSvgNameToComponent[props.icon]),
  // component: (props: IconProps) => h(props.tag, [h(customSvgNameToComponent[props.icon as string], { class: 'v-icon__svg' })]),
};

export { customSVGs /* aliases */, customSvgNameToComponent };